// Single source of truth for the public Journey ("Paths") section.
// The visual structure (phase, section, icon, image, features) lives here.
// Only the text fields in EDITABLE_FIELDS can be overridden from the admin dashboard.

export const EDITABLE_FIELDS = ["title", "description", "price", "price_note"];

export const SCOUT_IMAGE =
  "https://images.unsplash.com/photo-1609701113058-d6243c3c9311?w=1200&q=72&auto=format&fit=crop";

// section: "solo" | "scout" | "pack" | "premium"
export const JOURNEY_ITEMS = [
  {
    slug: "free-call",
    phase: "0",
    section: "solo",
    iconKey: "phone",
    title: "The Free Call",
    description:
      "A relaxed 15–20 minute video call to get to know each other and see whether we're the right fit. No script, no pressure: just an honest conversation about your dream and how we can help you land it in Spain.",
    price: "Free",
    price_note: "15–20 minutes",
    highlight: "free",
    features: [
      "1-on-1 video call, no obligation",
      "Honest, two-way fit assessment",
      "Same-week scheduling",
    ],
    ctaLabel: "Book your free call",
  },
  {
    slug: "the-blueprint",
    phase: "1",
    section: "solo",
    iconKey: "map",
    title: "The Blueprint",
    description:
      "An intensive 2–3 hour working session where we build your personalized, step-by-step roadmap: the exact legal, real-estate and logistical requirements for your specific case. You leave with a plan you could act on tomorrow.",
    price: "$400 – $600",
    price_note: "one-time",
    featured: true,
    features: [
      "2–3 hour deep-dive session",
      "Personalized step-by-step roadmap",
      "Legal, property & logistics mapped",
      "Built around your specific case",
    ],
    ctaLabel: "Start The Blueprint",
  },
  {
    slug: "the-scout",
    phase: "2",
    section: "scout",
    iconKey: "compass",
    title: "The Scout",
    description:
      "A guided visit to your destination to explore neighborhoods, schools, districts and services before you decide anything. You walk the streets you might call home, with us beside you, translating everything from café menus to school catchment areas.",
    price: "By application",
    price_note: "+ supplement per additional family member",
    features: [
      "Guided, in-person visit to Spain",
      "Neighborhoods, schools & services scouted",
      "Local introductions & honest advice",
    ],
    ctaLabel: "Apply for The Scout",
  },
  {
    slug: "visa-management",
    phase: "2",
    section: "pack",
    iconKey: "stamp",
    title: "Visa Management",
    description:
      "Full management of your residency visa: from the paperwork in the US all the way through to Europe. We prepare, file and follow every step, so you never face a consulate form alone.",
    price: "$1,700 – $2,800",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "fiscal-legal-study",
    phase: "2",
    section: "pack",
    iconKey: "scale",
    title: "Fiscal & Legal Study",
    description:
      "A tailored study of your specific situation on the tax and legal side (how your income, assets and residency interact across the US and Spain) with a written recommendation built entirely around your case.",
    price: "By application",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "consultancy-call",
    phase: "2",
    section: "pack",
    iconKey: "messages",
    title: "Consultancy Call",
    description:
      "A focused call to work through a specific piece of your move or your Blueprint: most often the tax and legal questions that keep you up at night. Bring your case; leave with clear answers.",
    price: "$250",
    price_note: "per call",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "real-estate",
    phase: "2",
    section: "pack",
    iconKey: "home",
    title: "Real Estate",
    description:
      "Finding your rental or purchase in Spain, matched to exactly what you need. We can also manage the sale of your property back home so nothing is left hanging.",
    price: "$1,700 – $2,200",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "school-search",
    phase: "2",
    section: "pack",
    iconKey: "school",
    title: "School Search",
    description:
      "We research and recommend the right schools for your children, matched to your family's needs, language preferences, curriculum and neighborhood. You get a shortlist you can trust, not a spreadsheet to decode.",
    price: "$250 – $300",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "health-insurance",
    phase: "2",
    section: "pack",
    iconKey: "heart",
    title: "Health Insurance",
    description:
      "We study and arrange a no-copay health policy that meets the requirements for your residency visa: no guesswork, no gaps in coverage.",
    price: "$120 – $180",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "basic-paperwork",
    phase: "2",
    section: "pack",
    iconKey: "file",
    title: "Basic Paperwork",
    description:
      "Independent handling of individual formalities (NIE, empadronamiento, bank set-up) for when you only need a few loose ends tied, not a full process.",
    price: "$280 – $450",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "the-moving",
    phase: "2",
    section: "pack",
    iconKey: "truck",
    title: "The Moving",
    description:
      "End-to-end coordination of your international move: pickup at origin, delivery at your new home in Spain, every box and every detail handled.",
    price: "$8,900 – $19,900",
    price_note: "",
    ctaLabel: "Enquire about this pack",
  },
  {
    slug: "end-to-end",
    phase: "2",
    section: "premium",
    iconKey: "crown",
    title: "End to End",
    description:
      "We handle absolutely everything: visas, housing, insurance, schools and complete hands-on support until the day you're fully settled in. Your single point of contact, from the first call to your first morning coffee on the terrace.",
    price: "By application",
    price_note: "fully bespoke",
    ctaLabel: "Apply for End to End",
  },
  {
    slug: "the-wingman",
    phase: "3",
    section: "solo",
    iconKey: "lifebuoy",
    title: "The Wingman",
    description:
      "Your personal concierge once you're settled in. Schools, doctors, social clubs, and any day-to-day need: one call and it's handled, all year long. The reassurance of a local friend who happens to know everyone.",
    price: "$1,200",
    price_note: "per year",
    features: [
      "Personal concierge, 12 months",
      "Schools, doctors & admin sorted",
      "Social clubs & local introductions",
      "Day-to-day life, one call away",
    ],
    ctaLabel: "Join The Wingman",
  },
];

// Merge admin overrides (keyed by slug) onto the catalog defaults.
export function mergeJourney(overrides) {
  const map = overrides || {};
  return JOURNEY_ITEMS.map((item) => {
    const ov = map[item.slug] || {};
    const merged = { ...item };
    EDITABLE_FIELDS.forEach((f) => {
      if (ov[f] !== undefined && ov[f] !== null && ov[f] !== "") {
        merged[f] = ov[f];
      }
    });
    return merged;
  });
}
